<div class="auction-card__BodyCard" routerLink="/auction-details/{{item['auction_id']}}">
  <span class="aution-type" *ngIf="auctionEntity">{{auctionEntity}}</span>
  <div class="auction-card__cardImg">
    <ng-container *ngIf="item['ProductImage']; then imageAvail else fallback"></ng-container>
    <ng-template #imageAvail>
      <div class="container">
        <div class="row">
          <div *ngFor="let imgItem of newImg;let last = last" [class]="imgItem['class'] + ' ' + 'p-0'">
            <img class="card-img-top" [src]="imgItem['img']"
              [style.height]="[1,2].includes(imageList.length) ? '220px' : ''" alt="Card image cap" />
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #fallback>
      <img class="" [src]="item['image'] ? item['image'] :  env+'assets/img/car-placeholder.png'" alt="Card image cap" style="height: 220px;" />
    </ng-template>
  </div>
  <div class="auction-card__CardBody px-1 pb-4">
    <div class="auction-card__cardAutionTime mb-2">
      <h5 class="card-title auction-card__cardTitle">
        {{ item["car_name"] }} &nbsp;
      </h5>
    </div>
    <ng-container *ngIf="['current', 'initialLive'].includes(auctionType)">
      <ng-container *ngIf="auctionType === 'current'">
        <div class="auction-card__liveBtnGroup p-2">
          <!-- <div class="auction-card__liveBtnIndicator mx-2"></div>
          <button type="submit" class="auction-card__liveBtn" id="second">
            Live
          </button> -->
        </div>
      </ng-container>
      <ng-container *ngIf="item['entity_type'] === 'individual_batch'">
        <ng-template [ngTemplateOutlet]="vehicleInfo"></ng-template>
      </ng-container>

      <ng-container *ngIf="item['entity_type'] !== 'individual_batch'">
        <ng-template [ngTemplateOutlet]="buyPriceInfo"></ng-template>
      </ng-container>

    </ng-container>
    <ng-container *ngIf="['future'].includes(auctionType)">
      <div class="col-12">
        <div class="auction-card__cardDescription mb-3 flex-column">
          <span class="auction-card__cardDescriptionText1">Auction Date
          </span>
          <span class="auction-card__cardDescriptionText">
            {{ item["live_start_date_time"] | date:'medium' }}
          </span>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="['future'].includes(auctionType)">
      <div class="auction-card__cardBtnGrp">
        <button type="button" class="auction-card__BtnTiming">
          COMING SOON
        </button>
      </div>
    </ng-container>
  </div>
</div>


  <ng-template #buyPriceInfo>
    <div class="auction-card__cardDescription W-100">
    <div class="container">
      <div class="row">
        <div class="col-7 col-sm-7 col-sm-7">
          <ul class="list-unstyled">
            <li class="auction-card__listKeys">Buy Now Price</li>
            <li class="auction-card__listKeys">Opening Price</li>
            <li class="auction-card__listKeys">Lowest Price</li>
          </ul>
        </div>
        <div class="col-5 col-sm-5 col-5 p-0">
          <ul class="list-unstyled">
            <li class="auction-card__listValues">
              SAR
              {{ item["buy_now_price"] ? (+item["buy_now_price"] | number : '1.0-2') : "--" }}
            </li>
            <li class="auction-card__listValues">
              SAR
              {{
                item["opening_price"] ? (+item["opening_price"] | number : '1.0-2') : "--"
              }}
            </li>
            <li class="auction-card__listValues">
              SAR
              {{ item["lowest_price"] ? (+item["lowest_price"] | number : '1.0-2'): "--" }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #vehicleInfo>
  <div class="auction-card__cardDescription W-100">
    <div class="container">
      <div class="row">
        <div class="col-7 col-sm-7 col-sm-7">
          <ul class="list-unstyled">
            <li class="auction-card__listKeys">Total Vehicles</li>
          </ul>
        </div>
        <div class="col-5 col-sm-5 col-5 p-0">
          <ul class="list-unstyled">
            <li class="auction-card__listValues">{{item?.['ProductInfo']?.length}}</li>
          </ul>
        </div>
        </div>
    </div>
  </div>
</ng-template>
